import { useRoute } from './lib/router.ts';
import { AppShell } from './components/AppShell.tsx';
import type { DataPort } from './adapters/port.ts';
import type { Sesion } from './adapters/http.ts';
import { Dashboard } from './views/Dashboard.tsx';
import { Briefs } from './views/Briefs.tsx';
import { Pipeline } from './views/Pipeline.tsx';
import { Approvals } from './views/Approvals.tsx';
import { Library } from './views/Library.tsx';
import { Integrations } from './views/Integrations.tsx';
import { DecisionEngine } from './views/DecisionEngine.tsx';
import { Architecture, UseCases, Playground, Manual, Faq, NotFound } from './views/Static.tsx';

export function App(
  { port, sesion, onSalir }:
  { port: DataPort; sesion?: Sesion | undefined; onSalir?: (() => void) | undefined },
) {
  const { route, path } = useRoute();

  return (
    <AppShell route={route} sourceLabel={port.sourceLabel} sesion={sesion} onSalir={onSalir} port={port}>
      {!route && <NotFound path={path} />}
      {route?.id === 'dashboard' && <Dashboard port={port} />}
      {route?.id === 'brief' && <Briefs port={port} />}
      {route?.id === 'pipeline' && <Pipeline port={port} />}
      {route?.id === 'aprobaciones' && <Approvals port={port} />}
      {route?.id === 'biblioteca' && <Library port={port} />}
      {route?.id === 'integraciones' && <Integrations port={port} />}
      {route?.id === 'decision' && <DecisionEngine port={port} />}
      {route?.id === 'arquitectura' && <Architecture />}
      {route?.id === 'casos' && <UseCases />}
      {route?.id === 'playground' && <Playground />}
      {route?.id === 'manual' && <Manual />}
      {route?.id === 'faq' && <Faq />}
    </AppShell>
  );
}
